export const sosyalMedya = {
  title: 'Sosyal Medya',
  titleEN: 'Social Media',
  description: 'Mackolik Instagram veya Twitter hesaplarından yapılan content entegreli çalışmalardır. Kampanyalarınızı rettiğimiz doğal içeriklerimizin içerisinde etkileşimi yksek olacak şekilde konumlandırıyoruz!',
  descriptionEN: 'These are content-integrated campaigns conducted through Mackolik\'s Instagram or Twitter accounts. We position your campaigns within our organically produced content to achieve high engagement!',
  tabs: [
    {
      id: 1,
      title: 'Sosyal Medya',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/f6518dbe2e7a0f00853932a55e0769c332e6135eb73e9da3a845551b2a42f36c.png',
          url: 'https://twitter.com/mackolik/status/1729225685967745304',
          category: 'Puan Durumu',
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/46f5ffe238a0b64f89cbae668eae681c360532a37f083de3c62e73f32c68f158.png',
          url: 'https://twitter.com/mackolik/status/1744674520194064893?s=20',
          category: 'Fikstür',

        }
      ]
    },
  ],
  egTabs: [
    {
      id: 1,
      title: 'Social Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/f6518dbe2e7a0f00853932a55e0769c332e6135eb73e9da3a845551b2a42f36c.png',
          url: 'https://twitter.com/mackolik/status/1729225685967745304',
          category: 'Table',
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/46f5ffe238a0b64f89cbae668eae681c360532a37f083de3c62e73f32c68f158.png',
          url: 'https://twitter.com/mackolik/status/1744674520194064893?s=20',
          category: 'Fixture',

        }
      ]
    },
  ]
}
